<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-title color="white">Dettaglio rapportino</ion-title>
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="start" :icon="arrowBackOutline" color="white"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div class="page_content">
                <!-- Img modal, triggered with click on ticket attachment -->
                <Transition name="fade-transition">
                    <div v-show="showImgModal" class="attachment_modal">
                        <div class="customers_container">
                            <img :src="selectedImage" alt="Foto rapportino" />
                        </div>
                        <div @click="closeAttachmentModal()" class="close_modal">Chiudi</div>
                    </div>
                </Transition>

                <div class="rapportino">
                    <div v-if="rapportino.rapportini_codice" class="field">
                        <div class="title">Codice</div>
                        <div class="value">#{{ rapportino.rapportini_codice }}</div>
                    </div>
                    <div class="field">
                        <div class="title">Cliente</div>
                        <div class="value">
                            {{ setShortCustomer(rapportino.customers_company) }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Commessa</div>
                        <div class="value">
                            {{ rapportino.projects_name ? rapportino.projects_name : "-" }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Data</div>
                        <div class="value">
                            {{ dateFormat(rapportino.rapportini_data) }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Orario</div>
                        <div class="value">
                            {{ rapportino.rapportini_ora_inizio + " - " + rapportino.rapportini_ora_fine }}
                        </div>
                    </div>
                    <div class="field_note description">
                        <div class="title">Operatori</div>
                        <div v-for="(operatore, index) in rapportino.rapportini_operatori" :key="index" class="value">
                            {{ operatore }}
                        </div>
                    </div>
                    <div class="field_note description">
                        <div class="title">Note</div>
                        <div class="value">
                            {{ rapportino.rapportini_note ? rapportino.rapportini_note : "-" }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Firma cliente</div>
                        <div class="value">
                            <span class="badge" :class="firmaClientePresente ? 'badge_low' : 'badge_high'">
                                {{ firmaClientePresente ? "Effettuata" : "Non effettuata" }}
                            </span>
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Firma tecnico</div>
                        <div class="value">
                            <span class="badge" :class="firmaTecnicoPresente ? 'badge_low' : 'badge_high'">
                                {{ firmaTecnicoPresente ? "Effettuata" : "Non effettuata" }}
                            </span>
                        </div>
                    </div>
                    <div v-if="rapportino.rapportini_prodotti" class="field_note description">
                        <div class="title">Prodotti usati</div>
                        <div class="value">
                            <div v-for="(prod, index) in rapportino.rapportini_prodotti" :key="index" class="value_product">{{ prod }}</div>
                        </div>
                    </div>
                    <!-- <div class="field_note description">
                        <div class="title">Immagini</div>
                        <div v-if="rapportino.rapportini_immagini" class="value">
                            <div class="images_container">
                                <div v-for="(image, index) in JSON.parse(rapportino.rapportini_immagini)" :key="index" @click="openImgDetail(image)" class="value">
                                    <ion-thumbnail>
                                        <img :src="setImageUrl(image)" />
                                    </ion-thumbnail>
                                </div>
                            </div>
                        </div>
                        <div v-else class="value">Nessuna foto caricata</div>
                    </div> -->
                    <div class="actions_container">
                        <div v-if="canModifyRapportino" class="foto_button" @click="openEditRapportino()">
                            Modifica rapportino
                        </div>
                        <div class="foto_button" @click="openImages()">
                            Visualizza foto
                        </div>
                        <div class="foto_button" @click="apriImmaginiCategorie()">
                            Scatta o carica foto
                        </div>
                    </div>
                </div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    //IonBackButton,
    IonTitle,
    IonContent,
    IonIcon,
    IonButton,
    //IonThumbnail,
    modalController,
} from "@ionic/vue";

import { defineComponent, ref, computed } from "vue";

import { arrowBackOutline } from "ionicons/icons";

import { dateFormat } from "@/services/utils";
import { openToast } from "@/services/toast";

import rapportiniAPI from "@/services/rapportini";

//import ModalFirmaIntervento from "@/components/ModalFirmaIntervento";
//import SalvaFotoRapportino from "@/components/rapportini/SalvaFotoRapportino";
import ModificaRapportino from "@/components/rapportini/ModificaRapportino";
import ImmaginiRapportino from "@/components/rapportini/ImmaginiRapportino";
import ImmaginiCategorie from "@/components/rapportini/ImmaginiCategorie";

export default defineComponent({
    name: "DettaglioRapportino",
    props: {
        data: {
            type: Object,
            required: true,
        },
        daRapportino: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        IonPage,
        IonHeader,
        IonToolbar,
        IonButtons,
        //IonBackButton,
        IonTitle,
        IonContent,
        IonIcon,
        IonButton,
        //IonThumbnail,
    },
    setup(props, context) {
        const rapportino = ref([]);
        rapportino.value = { ...props.data };

        function firmaPresente(val) {
            return val != null && String(val).trim() !== "";
        }

        const firmaClientePresente = computed(() => firmaPresente(rapportino.value.rapportini_firma_cliente));
        const firmaTecnicoPresente = computed(() => firmaPresente(rapportino.value.rapportini_firma_tecnico));

        /**
         * ! Handle close modal by clicking on Chiudi button
         */
        const closeModal = () => {
            modalController.dismiss();
        };

        /**
         * ! Limit customers to 35 charactes
         */
        function setShortCustomer(customer) {
            if (!customer) {
                return "-";
            } else {
                const trimmedString = customer.length > 35 ? customer.substring(0, 32) + "..." : customer;
                return trimmedString;
            }
        }

        /**
         * 
         * ! Edit rapportino
         * 
         */

        /**
         * ! Caricamento foto rapportino
         */
         async function editRapportino() {
            const modal = await modalController.create({
                component: ImmaginiCategorie,
                componentProps: {
                    rapportino_id: rapportino.value.rapportini_id,
                    rapportino: rapportino.value,
                },
            });
            modal.onDidDismiss().then((detail) => {
                console.log(detail);
                /* if (detail.data != undefined) {
                    const foto = detail.data;
                    if (foto) {
                        foto.forEach((singleFoto) => {
                            //console.log(singleFoto);
                            immaginiRapportino.value.push(singleFoto);
                        });
                    }
                } */
            });
            return modal.present();
        }

        /**
         * ! Caricamento foto rapportino
         */
        async function apriImmaginiCategorie() {
            const modal = await modalController.create({
                component: ImmaginiCategorie,
                componentProps: {
                    rapportino_id: rapportino.value.rapportini_id,
                    rapportino: rapportino.value,
                },
            });
            /* modal.onDidDismiss().then((detail) => {
                //console.log(detail);
                if (detail.data != undefined) {
                    const foto = detail.data;
                    if (foto) {
                        foto.forEach((singleFoto) => {
                            //console.log(singleFoto);
                            immaginiRapportino.value.push(singleFoto);
                        });
                    }
                }
            }); */
            return modal.present();
        }

        /**
         *
         * ! Visualizzazione foto caricate
         *
         */
        const immaginiRapportino = ref([]);
        async function openImages() {
            const modal = await modalController.create({
                component: ImmaginiRapportino,
                componentProps: {
                    rapportino_id: rapportino.value.rapportini_id,
                },
            });
            /*             modal.onDidDismiss().then((detail) => {
                //console.log(detail);
                if (detail.data != undefined) {
                    const foto = detail.data;
                    if (foto) {
                        foto.forEach((singleFoto) => {
                            //console.log(singleFoto);
                            immaginiRapportino.value.push(singleFoto);
                        });
                    }
                }
            }); */
            return modal.present();
        }

        /**
         *
         * ! Modifica dati base rapportino
         *
         */
        const editedRapportino = ref(false);
        async function openEditRapportino() {
            //console.log(rapportino.value);
            const modal = await modalController.create({
                component: ModificaRapportino,
                componentProps: {
                    data: rapportino.value,
                },
            });

            modal.onDidDismiss().then((detail) => {
                //console.log(detail);
                if (detail.data != undefined) {
                    editedRapportino.value = true;
                    rapportino.value.rapportini_ora_inizio = detail.data.rapportini_ora_inizio;
                    rapportino.value.rapportini_ora_fine = detail.data.rapportini_ora_fine;
                    rapportino.value.rapportini_note = detail.data.rapportini_note;
                    openToast("Rapportino modificato con successo", "toast_success");
                    //console.log(successResponse.value);
                    // console.log(detail.data);
                } else {
                    editedRapportino.value = false;
                }
            });

            return modal.present();
        }

        /**
         *
         * ! Open fake modal to view selected ticket attachment
         *
         */
        const selectedImage = ref(null);
        const showImgModal = ref(false);
        function openImgDetail(image) {
            showImgModal.value = true;
            selectedImage.value = `${process.env.VUE_APP_BASE_URL}/uploads/${image.path_local}`;
        }

        function closeAttachmentModal() {
            showImgModal.value = false;
        }

        function setImageUrl(img) {
            if (img) {
                return `${process.env.VUE_APP_BASE_URL}/uploads/${img.path_local}`;
            }
        }

        function parseRapportinoDate(dateTime) {
            if (!dateTime || typeof dateTime !== "string") {
                return null;
            }
            const [datePart, timePart] = dateTime.split(" ");
            if (!datePart || !timePart) {
                return null;
            }
            const [year, month, day] = datePart.split("-").map((value) => Number(value));
            const [hours, minutes, seconds] = timePart.split(":").map((value) => Number(value));
            if ([year, month, day, hours, minutes, seconds].some((value) => Number.isNaN(value))) {
                return null;
            }
            return new Date(year, month - 1, day, hours, minutes, seconds);
        }


        const canModifyRapportinoByTime = ref(false);
        const canModifyRapportino = ref(false);
        async function getModuleSettings() {
            try {
                const res = await rapportiniAPI.getSettings();

                if(res.status === 200 && res.data.status === 0) {
                    const settings = res.data.data[0];
                    const canModifyBySetting =
                        settings.impostazioni_rapportini_modifica_a_tempo &&
                        settings.impostazioni_rapportini_modifica_a_tempo == 1;
                    const createdAt = parseRapportinoDate(rapportino.value.rapportini_creation_date);

                    const isWithin24Hours = createdAt
                        ? Date.now() - createdAt.getTime() <= 24 * 60 * 60 * 1000
                        : false;

                    canModifyRapportinoByTime.value = canModifyBySetting;
                    canModifyRapportino.value = !canModifyRapportinoByTime.value || isWithin24Hours;
                }
            } catch (error) {
                openToast("Si è verificato un errore nel caricamento delle impostazioni", "toast_error");
                canModifyRapportinoByTime.value = false;
                canModifyRapportino.value = true;
            }
        }
        getModuleSettings();

        return {
            dateFormat,
            rapportino,
            firmaClientePresente,
            firmaTecnicoPresente,
            arrowBackOutline,
            closeModal,
            setShortCustomer,
            //Attachment modal
            showImgModal,
            selectedImage,
            openImgDetail,
            closeAttachmentModal,
            setImageUrl,
            // Modifica rapportino
            canModifyRapportinoByTime,
            canModifyRapportino,
            openEditRapportino,
            // Caricamento foto da camera nativa e scelta categorie
            apriImmaginiCategorie,
            // Immagini del rapportino
            openImages,
        };
    },
});
</script>

<style scoped>
ion-toolbar {
    --background: #086fa3;
    --color: #ffffff;
}
.loading_spinner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* New rules */
.page_content {
    width: 100%;
    position: relative; /* to be used for new intervento btn */
    padding: 16px;
    min-height: 100%;
    background: #f8fafc;
}

.rapportino .title_card {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 12px 0px;
    font-weight: 600;
    color: #475569;
}
.rapportino {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}
.rapportino .field {
    /* width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0px;
    margin-bottom: 10px;
    border-bottom: 1px solid #e2e8f0; */
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0px;
    border-bottom: 0.5px solid #7676803d;
}
.rapportino .field:first-child {
    padding-top: 0px;
}
.rapportino .field_note:last-of-type,
.rapportino .field_note:last-child,
.rapportino .field_note.description:last-of-type,
.rapportino .field_note.description:last-child {
    padding-bottom: 0px;
    border-bottom: none;
}

.rapportino .field_note {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px 0px;
}
.rapportino .field_note.description {
    border-bottom: 0.5px solid #7676803d;
}
.rapportino .field_note.description:last-of-type {
    border-bottom: none;
}
.field .title,
.field_note .title {
    font-size: 14px;
    font-weight: 500;
    color: #1d1d1b;
}
.field .ticket_title {
    text-transform: uppercase;
}
.field_note .title {
    margin-bottom: 8px;
}
.field .value,
.field_note .value {
    font-size: 14px;
}

.field_note .value .value_product {
    margin-bottom: 4px;
}

.value .badge {
    font-size: 10px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: bold;
}
.badge_low {
    background-color: rgb(220 252 231);
    color: rgb(34 197 94);
    font-weight: bold;
}
.badge_high {
    background-color: rgb(254 226 226);
    color: rgb(239 68 68);
    font-weight: bold;
}

.nuovo_intervento {
    width: 100%;
    margin-top: 16px;
    padding-bottom: 0;
    display: flex;
    justify-content: center;
}
.rapportino_button {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    background-color: #086fa3;
    color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
    transition: all 0.15s ease-in;
}

/* Elenco interventi */
.interventi_container {
    margin-top: 16px;
}
.interventi_container .interventi_label {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #2a2a2a;
}
.rapportino {
    /* width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1); */
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    border-radius: 8px;
    /* box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1); */
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px #00000040;
}
.rapportino .date {
    font-size: 14px;
    font-weight: 500;
    color: #475569;
}
.rapportino .status {
    font-size: 14px;
}

ion-button {
    --color: #ffffff;
}
/** Allegati  */
.allegati_container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow-x: scroll;
}
.allegati_container img {
    width: 200px;
    margin-right: 16px;
}
.rapportino .field_allegati {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px;
    border-bottom: 0.5px solid #7676803d;
}
.field_allegati .title {
    font-size: 14px;
    font-weight: 500;
    color: #475569;
}
.field_allegati .title {
    margin-bottom: 8px;
}
.field_allegati .value {
    font-size: 14px;
}

/** Modal selected attachment */
.fade-transition-enter-active,
.fade-transition-leave-active {
    transition: opacity 0.25s ease;
}

.fade-transition-enter-from,
.fade-transition-leave-to {
    opacity: 0;
}
.attachment_modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.75);
    color: #ffffff;
    padding: 24px;
    align-items: center;
}
.close_modal {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    color: #ffffff;
    background-color: #086fa3;
    font-size: 16px;
    font-weight: 500;
    border-radius: 20px;
    margin-top: 16px;
}

.title.rapportino_container {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    font-size: 16px;
}
a.link_rapportino {
    color: #086fa3;
    text-decoration: none;
}

/** Button foto */
.actions_container {
    width: 100%;
    padding: 12px 0;
    padding-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.foto_button {
    width: 100%;
    padding: 10px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    background-color: #086fa3;
    color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
    transition: all 0.15s ease-in;
}

/* Button firme */
.btn_firme_container {
    display: flex;
    gap: 20px;
}
.btn_firme_container .btn_firma {
    width: 100%;
    margin-top: 16px;
    padding-bottom: 0;
    display: flex;
    justify-content: center;
}
.btn_firma .firma_button,
.email_button {
    width: 100%;
    padding: 10px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    background-color: #086fa3;
    color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
    transition: all 0.15s ease-in;
}

.btn_firma .firma_button:disabled,
.btn_firma .firma_button:disabled,
.email_container .email_button:disabled {
    opacity: 0.6;
}

/**
* Anteprime foto
*/
.images_container {
    display: flex;
    justify-content: flex-start;
    gap: 16px;
    overflow-x: scroll;
    padding: 6px 0;
}
.singola_foto {
    display: flex;
    justify-content: center;
    align-items: center;
}
ion-thumbnail {
    --size: 150px;
    --border-radius: 4px;
}
</style>
